// extracted by mini-css-extract-plugin
export default {"root":"RemoveGroupButton__root--PYdYa"};